import React, { useContext } from 'react';
import { ToastContext } from '../components/ToastWrapper';

/**
 * Dispatch a Toast message to be shown to the user using the global ToastContext
 *
 * @usage   compose(withToastContext())((props) => { props.createToast('Hello there!'); })
 * @returns createToast as a prop
 */
export const withToastContext = () => Component => function(props) {
  const { createToast } = useContext(ToastContext);
  return <Component createToast={createToast} {...props} />;
};
